import Range from './range';
import './styles/index.scss';
Range.displayName = 'Range';
export default Range;
